import React, { useState } from 'react';
import moment from 'moment';
import Tooltip from "../Tooltip";
import { jsx as _jsx } from "react/jsx-runtime";
var DateValidator = function DateValidator(_ref) {
  var children = _ref.children,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur;
  var _useState = useState(null),
    error = _useState[0],
    setError = _useState[1];
  var handleChange = React.useCallback(function (event, data) {
    var _ref2 = data || {},
      value = _ref2.value;
    if (!value) return;
    var localError = null;
    if (moment(value) < moment(minDate) || moment(value) > moment(maxDate)) {
      localError = "Valeur entre " + moment(minDate).format('DD/MM/YYYY') + " et " + moment(maxDate).format('DD/MM/YYYY');
    }
    setError(localError);

    // Trigger the onChange function only if there is no error
    if (onChange && !localError) {
      onChange(event, value);
    }
  }, [onChange]);
  var handleBlur = React.useCallback(function (event, data) {
    var _ref3 = data || {},
      value = _ref3.value;
    if (!value) return;
    var localError = null;
    if (moment(value) < moment(minDate) || moment(value) > moment(maxDate)) {
      localError = "Valeur entre " + moment(minDate).format('DD/MM/YYYY') + " et " + moment(maxDate).format('DD/MM/YYYY');
    }
    setError(localError);

    // Trigger the onBlur function only if there is no error
    if (onBlur && !localError) {
      onBlur(event, value);
    }
  }, [onBlur]);
  return /*#__PURE__*/_jsx(Tooltip, {
    trigger: children({
      handleChange: handleChange,
      handleBlur: handleBlur,
      minDate: minDate,
      maxDate: maxDate
    }),
    type: error ? 'error' : undefined,
    message: error,
    mouseEnterDelay: 0
  });
};
DateValidator.handledProps = ["onBlur", "onChange"];
DateValidator.defaultProps = {
  onChange: undefined,
  onBlur: undefined
};
export default DateValidator;